import { useSubmitByEnter, useTriggerAction } from '@libs/hooks';
import { selectSubmitWidget, useAppSelector } from '@libs/store';
import React from 'react';
import styles from './PageWrapper.module.css';

export const PageWrapper = ({ children }: { children: React.ReactNode }) => {
    const submitWidget = useAppSelector(selectSubmitWidget);
    const { triggerActionsByType } = useTriggerAction(submitWidget);
    const handleKeyDown = useSubmitByEnter(submitWidget, { triggerActionsByType });

    return (
        <div className={styles.pageWrapper} onKeyDown={handleKeyDown}>
            {children}
        </div>
    );
};
